jQuery(document).ready(function ($) {
    const categories = $('.filters__categories');
    const orders = $('.filters__orders');

    const select = $('.filters__select');
    const option = $('.filters__option');

    const selected = $('.filters__selected');

    const grid = $('.archive-grid');

    $.fn.closeDropdown = function () {
        this.removeClass('active');
        this.next().hide();

        return this;
    }

    $.fn.toggleDropdown = function () {
        this.toggleClass('active');
        this.next().toggle();

        select.not(this).closeDropdown();

        return this;
    }

    $.fn.removeSelected = function () {
        const slug = this.getSlug();

        this.findFiltersSelect().find(`[data-category-slug="${slug}"]`).toggleOption();

        this.remove();

        return this;
    }

    $.fn.getName = function () {
        return this.attr('data-category-name');
    }

    $.fn.getSlug = function () {
        return this.attr('data-category-slug');
    }

    $.fn.getColour = function () {
        return this.attr('data-category-colour');
    }

    $.fn.findFiltersSelect = function () {
        return this.closest('.content').find('.filters__container');
    }

    $.fn.findFiltersList = function () {
        return this.closest('.content').find('.filters__list');
    }

    $.fn.findGrid = function () {
        return this.closest('.content').find('.archive-grid');
    }

    $.fn.collectFilters = function () {
        return this.map(function () {
            return $(this).attr('data-category-slug');
        }).get();
    }

    $.fn.toggleOption = function () {
        const name = this.getName();
        const slug = this.getSlug();
        const colour = this.getColour();

        this.toggleClass('active');

        const options = this.parent().find('.active');

        const selected_slugs = options.collectFilters();

        const filters_list = this.findFiltersList();

        if (filters_list.find(`[data-category-slug="${slug}"]`).length > 0) {
            filters_list.find(`[data-category-slug="${slug}"]`).remove();
        }
        else {
            filters_list.append(createSelectedTag(name, slug, colour));
        }

        console.log(selected_slugs);

        this.findGrid().getPosts(selected_slugs, this.closest('.filters__container').find('.filters__orders').find('.active').getSlug());

        return this;
    }

    $.fn.toggleOrder = function () {
        const name = this.getName();
        const slug = this.getSlug();
        const is_active = this.hasClass('active');

        this.parent().find('.active').removeOrder();

        this.toggleClass('active');

        this.parent().prev().find('span span').text(name);

        if (!is_active) {
            this.findGrid().getPosts([], slug);
        }

        return this;
    }

    $.fn.removeOrder = function () {
        this.removeClass('active');

        return this;
    }

    function createSelectedTag(name, slug, colour) {
        const span = `<span class="filters__selected ${colour}-content" data-category-slug="${slug}" data-category-name="${name}" data-category-colour="${colour}">${name}</span>`;

        return $(span);
    }

    // from grid
    $.fn.getPosts = function (filters = [], order = 'latest') {
        if (this.attr('data-category-slug')) {
            filters = [this.attr('data-category-slug')];
        }

        else if (filters.length === 0 && this.findFiltersSelect().length > 0) {
            filters = this.findFiltersSelect().find('.filters__categories').find('.filters__options').find('.active').collectFilters();
        }

        const post_type = $('.filters').attr('data-post-type');

        const ajax_data = {
            post_type: post_type,
            filters: filters.join(','),
            order: order,
            page: this.attr('data-page'),
            action: 'get_posts',
            nonce: blogs.nonce
        };

        const _this = this;

        $.ajax({
            url: blogs.ajax_url,
            type: 'POST',
            data: ajax_data,

            beforeSend: function () {
                console.log('loading');
            },

            success: function (response) {
                $(_this).find('.archive-grid__container').html(response.data.posts);
            },

            complete: function () {
                console.log('complete');
            }
        });

        return this;
    }

    select.on('click', function (event) {
        event.preventDefault();

        $(this).toggleDropdown();
    });

    categories.find('.filters__option').on('click', function (event) {
        event.preventDefault();

        $(this).toggleOption();
    });

    orders.find('.filters__option').on('click', function (event) {
        event.preventDefault();

        $(this).toggleOrder();
    });

    $(document).on('click', '.filters__selected', function (event) {
        $(this).removeSelected();
    });

    $(document).on('click', function (event) {
        if (!$(event.target).hasClass('filters__options') &&
            $(event.target).closest('.filters__categories').length === 0 &&
            $(event.target).closest('.filters__orders').length === 0) {
            select.closeDropdown();
        }
    });

    if (categories.length > 0 || orders.length > 0) {
        grid.getPosts();
    }
});